import { ComponentProps } from 'react';

import { cn } from 'src/lib/utils';

import { DialogTitle } from 'src/components/ui/dialog';

export default function CustomModalTitle({
  className,
  ...props
}: ComponentProps<typeof DialogTitle>) {
  return (
    <DialogTitle
      className={cn('tw:text-xl tw:leading-tight tw:font-medium', className)}
      {...props}
    />
  );
}
